import type { SurveyPage } from '../../fetchSurvey/types';
import type { LogicContext } from '../../surveyLogic/types';
import { trackPageSkipped } from '../../surveyLogic/telemetry/logicTelemetry';
import type { SurveyPaginationRefs } from '../types';
import { pushPageHistory } from './pageHistory';
import {
  resolveDisplayEmptyPageRelocation,
  type DisplayEmptyPageRelocation,
} from './resolveDisplayEmptyPageRelocation';

function markSkippedPagesUntil(
  refs: SurveyPaginationRefs,
  fromPageIndex: number,
  toPageIndex: number
): void {
  for (let i = fromPageIndex + 1; i < toPageIndex; i += 1) {
    refs.skippedPageIndices.add(i);
    refs.visitedPageIndices.delete(i);
  }
}

export function applyDisplayEmptyPageRelocation(
  refs: SurveyPaginationRefs,
  pages: SurveyPage[],
  currentPageIndex: number,
  context: LogicContext
): DisplayEmptyPageRelocation | null {
  const relocation = resolveDisplayEmptyPageRelocation(pages, currentPageIndex, context);
  if (!relocation || relocation.action === 'submit') {
    return relocation;
  }

  const { pageIndex } = relocation;
  if (pageIndex !== currentPageIndex + 1) {
    trackPageSkipped({
      fromPageIndex: currentPageIndex,
      toPageIndex: pageIndex,
      reason: 'empty_page',
    });
  }

  markSkippedPagesUntil(refs, currentPageIndex, pageIndex);
  refs.skippedPageIndices.delete(pageIndex);
  pushPageHistory(refs, currentPageIndex, pageIndex);
  refs.visitedPageIndices.add(pageIndex);

  return relocation;
}
